const defaultConfig = {
  appVersion: '2.0.6'
}
export default defaultConfig
